import "./_common";
import { GlobalComponents, GlobalStores } from "../react_isomorphic/global";
import { AuthorComponents, AuthorStores } from "../react_isomorphic/author_bundle";
import { HomeComponents, HomeStores } from "../react_isomorphic/home";
import { merge } from "lodash";

window.ReactComponents = merge(window.ReactComponents, GlobalComponents, AuthorComponents, HomeComponents);
window.ReactStores = merge(window.ReactStores, GlobalStores, AuthorStores, HomeStores);
